/* eslint-disable @next/next/no-img-element */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import LazyLoad from 'react-lazyload';
import ImageComponent from './ImageComponent';

const CarouselImage = ({
  deal = {},
  image = {},
  onClick = undefined,
  disableClickAction = false,
  lazy = false,
  load = false,
}) => {
  const [active, setActive] = useState(() => load);

  useEffect(() => {
    if (load && !active) {
      setActive(load);
    }
  }, [load, active]);

  if (!active) {
    return null;
  }

  const onAction = () => {
    if (onClick && !disableClickAction) {
      onClick();
    }
  };

  return (
    <>
      <div
        className={classNames('single-image')}
        onClick={onAction}
        onKeyPress={(event) => event.key === 'Enter' && onAction()}
        role="button"
        tabIndex="-1"
      >
        {lazy ? (
          <LazyLoad offset={500} once>
            <ImageComponent deal={deal} image={image} />
          </LazyLoad>
        ) : (
          <ImageComponent deal={deal} image={image} />
        )}
      </div>
      <style jsx>{`
        .single-image {
          display: block;
          cursor: pointer;
          height: 0;
          width: 100%;
          padding-bottom: 66.9%;
        }
        .single-image:focus-visible {
          outline-offset: -5px;
        }
        :global(.single-image__picture) {
          display: block;
        }
        :global(.single-image__image) {
          width: 100%;
        }
      `}</style>
    </>
  );
};

CarouselImage.propTypes = {
  deal: PropTypes.object,
  disableClickAction: PropTypes.bool,
  image: PropTypes.object,
  lazy: PropTypes.bool,
  load: PropTypes.bool,
  onClick: PropTypes.func,
};

export default CarouselImage;
